import { render } from "./pied_de_page.vue?vue&type=template&id=0bc2253b"
import script from "./pied_de_page.vue?vue&type=script&lang=js"
export * from "./pied_de_page.vue?vue&type=script&lang=js"

import "./pied_de_page.vue?vue&type=style&index=0&id=0bc2253b&lang=css"

import exportComponent from "C:\\Users\\bodin\\Documents\\projects\\lescouleursdelavie\\frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__